<template>
  <div class="content">
    <b-modal id="modal" ref="modal" v-bind="modal.options" @hide="hide" @shown="shown">
      <span v-if="!modal.allowsHtml">
        {{ modal.message }}
      </span>
      <span v-if="modal.allowsHtml" v-html="modal.message">
      </span>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: "generic-confirm",
    props: {
      options: {
        type: Object,
        default: () => ({
          title: 'Please Confirm Your Request'
        })
      },
      message: {
        type: String,
        default: () => 
          'Are you sure you wish to take this action?'
      }
    },
    data() {
      return {
        modal: {
          resolve: null,
          reject: null,
          options: { },
          message: null,
          allowsHtml: false
        }
      };
    },
    methods: {
      confirm(newMessage, newOptions, allowsHtml) {
        return new Promise((resolve, reject) => {
          this.modal.options = Object.assign({}, this.options, newOptions || {});
          this.modal.message = newMessage ? newMessage : this.message;
          this.modal.resolve = resolve;
          this.modal.reject = reject;
          this.modal.allowsHtml = typeof allowsHtml !== 'undefined' ? allowsHtml : this.modal.allowsHtml;
          return this.$refs.modal.show();
        });
      },
      hide(event) {
        if (event.trigger === 'ok') {
          this.$emit('confirmed');
          if (this.modal.resolve) {
            this.modal.resolve();
          }
        } else {
          this.$emit('cancelled');
          if (this.modal.reject) {
            this.modal.reject();
          }
        }
      },
      shown(event) {
        this.$emit('shown');
      }
    }
  };
</script>